const LOGISTICA_AMBEV_EMBED_URL = 'https://demia.com.br/embed/zOVY1m4TnI.js'
const LOGISTICA_AMBEV_COMPANY = 'logisticaambev'
const REVENDAS_AMBEV_EMBED_URL = 'https://demia.com.br/embed/NXVn4nazj_.js'
const REVENDAS_AMBEV_COMPANY = 'Revendas Ambev'

export function buildDemiaVariants({
  logisticaAmbevEcosystemId,
  revendasAmbevEcosystemId
}) {
  const variants = [
    {
      ecosystemId: logisticaAmbevEcosystemId ?? '',
      embedUrl: LOGISTICA_AMBEV_EMBED_URL,
      company: LOGISTICA_AMBEV_COMPANY
    },
    {
      ecosystemId: revendasAmbevEcosystemId ?? '',
      embedUrl: REVENDAS_AMBEV_EMBED_URL,
      company: REVENDAS_AMBEV_COMPANY
    }
  ]

  return variants.filter((variant) => variant.ecosystemId)
}

export function resolveDemiaVariant(ecosystems, variants) {
  for (const ecosystem of ecosystems) {
    const variant = variants.find((item) => item.ecosystemId === ecosystem._id)
    if (variant) return variant
  }
  return null
}
